import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AuthCallback } from '@/auth';
import { usePagesRoutes } from '@/pages';

const App = () => {
  const pageRoutes = usePagesRoutes();

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/auth/callback' element={<AuthCallback />} />

        {pageRoutes}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
